import React from 'react';
import './WrapperBox.scss'

const WrapperBox: React.SFC<{ 
  style?: string;
  withBorder?: boolean;
}> = ({ 
  style = '',
  withBorder = true,
  children,
}) => (
  <div className={ `wrapper-box ${ withBorder && 'border' } ${ style }` }>
    { children }
  </div>
);

export default WrapperBox;


// WEBPACK FOOTER //
// ./src/components/Shared/WrapperBox/WrapperBox.tsx